import { userType } from "../../../DTO";
import { Api } from "../../api";

export const ActivateSlide = (
    user: userType,
    lessonId: number,
    slideId: number,
) => {
    return new Promise<{ data: any }>((resolve, reject) => {
        const api = new Api({
            method: "patch",
            path: `lesson/${lessonId}/slide/${slideId}/activate`,
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
        });

        return api
            .call()
            .then((data: any) => {
                return resolve({ data });
            })
            .catch((error: any) => reject(error.data.message));
    });
};
